import React from 'react';
import { Helmet } from 'react-helmet';

import {
  SITE_NAME,
  SITE_URL,
  DEFAULT_IMAGE,
  DEFAULT_DESCRIPTION,
  getJsonLd,
} from './seo/routes';

export default function SEO({
  title = SITE_NAME,
  description = DEFAULT_DESCRIPTION,
  canonical = `${SITE_URL}/`,
  image = DEFAULT_IMAGE,
  robots = 'index,follow',
  type = 'website',
  author,
  publishedTime,
  localBusiness,
}) {
  const fullTitle = title === SITE_NAME ? title : `${title} | ${SITE_NAME}`;
  const jsonLdData = getJsonLd({
    title,
    description,
    canonical,
    image,
    type,
    author,
    publishedTime,
    localBusiness,
  });
  const jsonLd = jsonLdData
    ? JSON.stringify(jsonLdData).replace(/</g, '\\u003c')
    : null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      {author ? <meta property="article:author" content={author} /> : null}
      {publishedTime ? (
        <meta property="article:published_time" content={publishedTime} />
      ) : null}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd ? (
        <script type="application/ld+json">{jsonLd}</script>
      ) : null}

      <link rel="dns-prefetch" href="//www.googletagmanager.com" />
      <link
        rel="sitemap"
        type="application/xml"
        title="Sitemap"
        href={`${SITE_URL}/sitemap.xml`}
      />
    </Helmet>
  );
}
